module.exports = __webpack_public_path__ + "static/media/hiw-alone1.736e17c9.svg";